import { fetchApiAdmin, throwIfNotOk } from './http'
import type { SdsConsumerAsyncJobStatusResponse } from './job-types'
import type { JsonResponse, SdsConsumerOperation } from './types'

type GetBackfillMatchesStatusOperation = SdsConsumerOperation<'get-sds-consumer-backfill-matches-status'>

export type BackfillMatchesStatusResponse = JsonResponse<
  GetBackfillMatchesStatusOperation,
  SdsConsumerAsyncJobStatusResponse
>

export async function getBackfillMatchesStatus(): Promise<BackfillMatchesStatusResponse> {
  const response = await fetchApiAdmin('/sds-consumer/matches/backfill/status', {
    method: 'GET',
  })

  await throwIfNotOk(response)
  return response.json()
}

export const backfillMatchesStatusQuery = () => ({
  queryKey: ['sds-consumer-backfill-status'],
  queryFn: getBackfillMatchesStatus,
})
